const INITIAL_STATE = {
    counterRequest: 0,
};

function counterRequestReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'counterRequest/increment':
            return { ...state, counterRequest: state.counterRequest + 1 };

        case 'counterRequest/decrement':
            if (state.counterRequest - 1 < 0) return state;

            return { ...state, counterRequest: state.counterRequest - 1 };

        default:
            return state;
    }
}

export default counterRequestReducer;
